import React from 'react';
import { useAtomCallback, useAtomValue } from '@exodus/headless-ui';
import { fromAssetAtom, fromWalletAccountAtom, isLoadingAtom } from '../../../atoms/index.js';
const FromWalletAccount = ({ Component, className, style, onPress, }) => {
    const isLoading = useAtomValue(isLoadingAtom);
    const fromWalletAccount = useAtomValue(fromWalletAccountAtom);
    const handlePress = useAtomCallback(async (get, set) => {
        const result = await onPress({
            side: 'from',
            assetName: get(fromAssetAtom).name,
            currentWalletAccount: get(fromWalletAccountAtom),
        });
        if (result)
            set(fromWalletAccountAtom, result);
    }, [onPress]);
    if (Component) {
        return (React.createElement(Component, { walletAccount: fromWalletAccount, loading: isLoading, className: className, style: style, onPress: handlePress }));
    }
    return null;
};
export default FromWalletAccount;
